import PropTypes from "prop-types"
import { isNull, get } from "lodash"
import { Dialog, DialogContent, DialogActions, Button, DialogTitle, Alert } from "@mui/material"
import CopyableTextField from "components/copyable-text-field"
import "./style.scss"

export default function TokenConfirmationDialog({ showDialog, token, onClose }) {
  return showDialog && token && <Dialog className="modules_tokens_components_token-confirmation-dialog" open={!isNull(token)} onClose={onClose}>
    <DialogTitle>Generated token</DialogTitle>
    <DialogContent>
      <div className="banner">
        <Alert severity="warning">You will not be able to view the token secret again once you close this window, so be sure to record it securely.</Alert>
      </div>
      <div className="token-fields">
        <CopyableTextField id="token-id" label="Token ID" value={get(token, "id")} />
        <CopyableTextField id="token-value" label="Secret" value={get(token, "secret")} />
      </div>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="secondary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
}

TokenConfirmationDialog.propTypes = {
  showDialog: PropTypes.bool,
  token: PropTypes.shape({
    id: PropTypes.string.isRequired,
    secret: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
}
